import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/",
      name: "home",
      component: () => import("@/views/Landing.vue"),
      meta: {
        pageTitle: "Home",
        breadcrumb: [
          {
            text: "Home",
            active: true,
          },
        ],
        layout: "full",
      },
    },
    // {
    //   path: "/bot",
    //   name: "chatbot",
    //   component: () => import("@/views/chatbot/Chatbot.vue"),
    //   meta: {
    //     layout: "full",
    //   },
    // },
    {
      path: "/market",
      name: "Marketplace",
      component: () => import("@/views/MarketPlace/Main.vue"),
      meta: { pageTitle: "Market", layout: "full" },
    },
    // {
    //   path: "/login",
    //   name: "login",
    //   component: () => import("@/views/Login.vue"),
    //   meta: {
    //     layout: "full",
    //   },
    // },
    {
      path: "/oauth-callback",
      name: "oauth-callback",
      component: () => import("@/auth/OAuthCallback.vue"),
      meta: {
        layout: "full",
      },
    },
    {
      path: "/error-404",
      name: "error-404",
      component: () => import("@/views/error/Error404.vue"),
      meta: {
        layout: "full",
      },
    },
    {
      path: "*",
      redirect: "error-404",
    },
  ],
});

router.beforeEach((to, _, next) => {
  // Set Page Title
  const DEFAULT_TITLE = "Market";
  Vue.nextTick(() => {
    document.title = to.meta.pageTitle || DEFAULT_TITLE;
  });

  return next();
});

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }
});

export default router;
